import CONSTANTS from './constants.js';

const REDUCER = (state = CONSTANTS.DEFAULT_STATE,action) => {
    let returnState = Object.assign({},state);
    
    switch(action.type){
        case CONSTANTS.ACTIONS.INSTRUMENT:
            returnState.name = action.text;
    }
    
    return returnState;
};

export default REDUCER;